export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/streamlabs_obs.eccccc2.svg";